module.exports = __webpack_public_path__ + "static/media/hardware-banner5.c5ecd53a.png";